import React, { FC } from 'react';
import { useOutletContext } from 'react-router-dom';

import { Icon } from '@column/column-ui-kit';

import { RestrictedBanner } from '~/components';
import { ReportDownloadMenu } from '~/components/ReportDownloadMenu';
import { ReportingTable } from '~/components/ReportingTable';
import { useSessionStore } from '~/stores/Session';
import { Inner } from '~/styles';

import { BankAccountSectionProps } from './Section';

export const PageBankAccountsDocuments: FC = () => {
  const { isAuthorized } = useSessionStore();
  const { bankAccount } = useOutletContext<BankAccountSectionProps>();

  const hasReportingPermissions = isAuthorized({
    permission: 'reporting',
    permissionLevel: 'read',
    bankAccount: { id: bankAccount.id, owners: bankAccount.owners },
  });

  return (
    <>
      {!hasReportingPermissions && (
        <Inner pt={0}>
          <RestrictedBanner />
        </Inner>
      )}
      <Inner p={0} pt={12}>
        <ReportingTable
          tableId="statements"
          bankAccountId={bankAccount.id}
          filter={{ category: 'statement' }}
          empty={{
            icon: <Icon.AnimationDocument />,
            title: 'No documents found',
            description: 'Wait for your first statements to get generated.',
          }}
          overwriteEntryObject={(entry, object) => ({
            ...object,
            action: <ReportDownloadMenu report={entry} size="xs" variant="secondary" />,
          })}
        />
      </Inner>
    </>
  );
};
